
import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import store from "./../store";
import { systemSrv } from '@/services/system';

@Component({
  components: {}
})
export default class Quiz extends Vue {
  authAPIUrl = this.$store.getters.config.authAPIUrl;
  submitted = false;
  processing = false;
  errorMessage = "";

  quizComplete = false
  quizState:any = {
      questionNo:1,
      currentOption:0,
      answers:{}
  }
  quiz = {
    questions:[
      {
        title:"What are your weekends like?", 
        no:1,
        options:[
          {
            name:"Trend Setter", 
            images:[
              "images/personas/1-0.png"
            ]
          },
          {
            name:"Digital Genius", 
            images:[
              "images/personas/1-1.png"
            ]
          },
          {
            name:"Smart Spender", 
            images:[
              "images/personas/1-2.png"
            ]
          },
          {
            name:"Family Hero", 
            images:[
              "images/personas/1-3.png"
            ]
          },
          {
            name:"Golden Groover", 
            images:[
              "images/personas/1-4.png"
            ]
          }
        ]
      },
      {
        title:"Which visual best describes you?", 
        no:2,
        options:[
          {
            name:"Trend Setter", 
            images:[
              "images/personas/2-0.png"
            ]
          },
          {
            name:"Digital Genius", 
            images:[
              "images/personas/2-1.png"
            ]
          },
          {
            name:"Smart Spender", 
            images:[
              "images/personas/2-2.png"
            ]
          },
          {
            name:"Family Hero", 
            images:[
              "images/personas/2-3.png"
            ]
          },
          {
            name:"Golden Groover", 
            images:[
              "images/personas/2-4.png"
            ]
          }
        ]
      },
      {
        title:"Which visual best describes you?", 
        no:3,
        options:[
          {
            name:"Trend Setter", 
            images:[
              "images/personas/3-0.png"
            ]
          },
          {
            name:"Trend Setter", 
            images:[
              "images/personas/3-0a.png"
            ]
          },
          {
            name:"Digital Genius", 
            images:[
              "images/personas/3-1.png"
            ]
          },
          {
            name:"Digital Genius", 
            images:[
              "images/personas/3-1a.png"
            ]
          },
          {
            name:"Smart Spender", 
            images:[
              "images/personas/3-2.png"
            ]
          },
          {
            name:"Family Hero", 
            images:[
              "images/personas/3-3.png"
            ]
          },
          {
            name:"Golden Groover", 
            images:[
              "images/personas/3-4.png"
            ]
          }
        ]
      }
    ]
  }

  CACHE_KEY_TOKEN = store.getters.tokenKeys.CACHE_KEY_TOKEN;


  constructor() {
    super();
  }
  created() {
     window.scrollTo(0,0);
    this.quizState.questionNo = 1
    this.quizState.currentOption = 0
    var cached = cacheSrv.cached("answers")
    this.quizState['answers'] = Object.assign({}, this.quizState['answers'], cached?cached:{})
  }

  goNext(){
    var current = parseInt(this.quizState['questionNo'])
    if(current<this.quiz.questions.length){
      this.quizState.questionNo=current+1
      this.quizState.currentOption = 0
    }
    
  }
  goPrev(){
    var current = parseInt(this.quizState['questionNo'])
    if(current>=1){
      this.quizState.questionNo=current-1
      this.quizState.currentOption = 0
    }
    
  }
  updateAnswer(question, persona, optionIndex){
    console.log("Updating updateAnswer", question.no, persona.name, optionIndex)
    if(!this.quizState['answers'][question.no]){
      console.log("No answers for questionNo. setting up new set")
      //this.quizState['answers'][question.no] = {no:question.no, selected:{}}
      let sel = {}
      sel[optionIndex] = {value:"1", name:persona.name}
      let obj = {}
      obj[question.no] = {no:question.no, selected:sel}
      this.quizState['answers'] = Object.assign({}, this.quizState['answers'], obj)
    }
    else{
      let sel = this.quizState['answers'][question.no]['selected']
      if(sel[optionIndex] && sel[optionIndex]['value']=="1"){
        delete sel[optionIndex] 
      }
      else{
        sel[optionIndex] = {value:"1", name:persona.name}
      }
      this.quizState['answers'][question.no]['selected'] = Object.assign({}, this.quizState['answers'][question.no]['selected'], sel)
    }
    cacheSrv.cache("answers",this.quizState['answers'])
    this.personaCalculation()
  }
  setSlideOption(question, persona, index){
    console.log("Updating setSlideOption", question.key, persona.name, index)
    this.quizState['currentOption'] = index
  }
  personaCalculation(){
    var answers = this.quizState['answers']
    let asnwerNos = Object.keys(answers)
    console.log("personaCalculation keys",asnwerNos)
    let answerCount = this.quiz.questions.length
    if(answerCount>asnwerNos.length){
      console.log("NOt all questions completed")
      return false
    }
    var validSelected = true
    var personaSelected:any[] = []
    asnwerNos.forEach(questionNo=>{
      if(answers[questionNo]['selected']){
        let optionsSelected = Object.keys(answers[questionNo]['selected'])
        console.log("QuestionNo:", questionNo, ", options selected", optionsSelected)
        if(optionsSelected.length==0){
          validSelected = false
        }
        optionsSelected.forEach(optSel=>{
          let ssel = answers[questionNo]['selected'][optSel]
          if(ssel){
            personaSelected.push(ssel['name'])
          }
          
        })
      }
      else{
        validSelected = false
      }
      
    })
    console.log("personaSelected",personaSelected)
    if(validSelected){
      this.quizComplete = true
      var map = personaSelected.reduce(function (p, c) {
          p[c] = (p[c] || 0) + 1;
          return p;
      }, {});
      console.log("map",map)
      var keysSorted = Object.keys(map).sort(function(a,b){return map[b]-map[a]})

      keysSorted = keysSorted.slice(0,3)
      console.log("May proceed. All questions answerd", keysSorted)
      var dynamicFieldList: any[] = []
      var LETTER = 65
      keysSorted.forEach(itm=>{
        dynamicFieldList.push({name:"Persona"+String.fromCharCode(LETTER), colValue:itm, type:"persona"})
        LETTER++
      })
      console.log("dynamicFieldList",dynamicFieldList)
      return dynamicFieldList
    }
    else{
      this.quizComplete = false
      console.log("Quiz not complete")
      
    }
  }

  goHome(){
    cacheSrv.remove("answers")
    router.push("home");
    store.commit("setMenu", true);
  }
  async updateMemberProfileWithPersona() {
    this.processing = true;
    let personaArray = this.personaCalculation()
    if(this.quizComplete){
      let token = cacheSrv.cached(this.CACHE_KEY_TOKEN);
      if (!token) {
        console.log("No token");
        router.push("login");
        return;
      }

      try {
        let payload = {dynamicFieldLists:personaArray}
        let data = await systemSrv.updateMemberDynamicFields(payload);
        this.processing = false;
        if (data) {
          if (data["error"]) {
            console.log("Error updating profile");
            this.errorMessage = data["meta"].original.error.message;
            return;
          }
          //let notiId = notiSrv.sayNoti("Profile updated", 2000)
          systemSrv.storeProfileLocally(data["profile"])
          
          this.quizState.questionNo = 0
          
        } else {
          console.log("Error in updating profile. No data");
        }
      } catch (error) {
        console.log("Error while updating profile. ", error);
        this.errorMessage = "Error while updating profile. " + error.error;
      }
    }
    else{
      this.processing = false;
      var completed = Object.keys(this.quizState['answers'])
      this.errorMessage = "Please complete all questions. So far, you have completed questions: " + (completed?completed:"None")
    }
    
  }


}
